import Container from '~/components/Container';
import Button from '~/components/Button';
import Reveal from '~/components/Reveal';
import PlanCard from '~/components/PlanCard';
import ProvidedBy from '~/components/ProvidedBy';
import { PLANS, PLAN_INCLUDES } from '~/data/plans';
import { useTitle } from '~/lib/useTitle';
import s from './Pricing.module.scss';

const FAQ = [
  {
    q: 'What counts as an API call?',
    a: 'Each metadata request — a search, a lookup or a catalog fetch — counts as one call. Allowances reset monthly.',
  },
  {
    q: 'Can I use MetaHub commercially?',
    a: 'Yes. Every plan includes a commercial-use license for apps on iOS, Android, desktop and web.',
  },
  {
    q: 'How does the lifetime plan work?',
    a: 'Pay once and keep access forever, with a higher monthly call allowance and no recurring charges.',
  },
  {
    q: 'Can I change plans later?',
    a: 'You can upgrade at any time. Billing and subscriptions are handled securely through your Stremio account.',
  },
];

export default function Pricing() {
  useTitle('Pricing — MetaHub');

  return (
    <>
      <section className={s.head}>
        <div className={s.orb} aria-hidden="true" />
        <Container>
          <Reveal>
            <div className={s.kicker}>Pricing</div>
            <h1>Pricing that scales with your app.</h1>
            <p>Three straightforward plans. No hidden fees, no per-seat pricing — just metadata.</p>
          </Reveal>
        </Container>
      </section>

      <section className={s.plansSection}>
        <Container>
          <div className={s.plans}>
            {PLANS.map((p, i) => (
              <Reveal key={p.id} delay={i * 90}>
                <PlanCard plan={p} />
              </Reveal>
            ))}
          </div>
          <ProvidedBy />
        </Container>
      </section>

      <section className={s.includes}>
        <Container className={s.includesInner}>
          <Reveal className={s.includesCopy}>
            <div className={s.kicker}>Every plan includes</div>
            <h2>One API, the whole catalog.</h2>
            <p>Every MetaHub subscription unlocks the full dataset.</p>
          </Reveal>
          <Reveal className={s.includesListWrap}>
            <ul className={s.includesList}>
              {PLAN_INCLUDES.map((f) => (
                <li key={f}>
                  <span className={s.check} aria-hidden="true" />
                  {f}
                </li>
              ))}
            </ul>
          </Reveal>
        </Container>
      </section>

      <section className={s.faq}>
        <Container>
          <Reveal>
            <h2 className={s.faqTitle}>Frequently asked questions</h2>
          </Reveal>
          <div className={s.faqList}>
            {FAQ.map((item, i) => (
              <Reveal key={item.q} delay={i * 60}>
                <div className={s.faqItem}>
                  <h3>{item.q}</h3>
                  <p>{item.a}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </Container>
      </section>

      <section className={s.cta}>
        <Container>
          <Reveal className={s.ctaInner}>
            <h2>Ready when you are.</h2>
            <p>Get the most complete metadata API powering your app in minutes.</p>
            <Button to="/payment?plan=yearly" size="lg">
              Get API access
            </Button>
          </Reveal>
        </Container>
      </section>
    </>
  );
}
